import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchVenueById, updateVenue } from '../../../services/Http/Api';
import VenueDetails from './VenueDetails';
import VenueStatistic from './VenueStatistic';
import VenueIntegration from './VenueIntegration';
import VenueForm from '../../global/Venue/VenueForm';
import { useTranslation } from 'react-i18next';
import { MdDashboard, MdBarChart, MdCode, MdEdit } from "react-icons/md";
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import TabBar from '../../../shared/layout/tabs/TabBar';
import TabButton from '../../../shared/layout/tabs/TabButton';

const VenueView = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const [venue, setVenue] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('details');

    useEffect(() => {
        const loadVenue = async () => {
            try {
                const response = await fetchVenueById(id);
                setVenue(response);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching venue:', error);
            }
        };

        loadVenue();
    }, [id]);

    const handleSave = async (updatedVenueData) => {
        try {
            await updateVenue(id, updatedVenueData);
        } catch (error) {
            console.error('Error saving venue:', error);
        }
    };

    if (loading) {
        return (
            <PageContainer>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '6.25rem' }}>
                    {t('Venues.VenueView.loading')}
                </div>
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle>{venue.name}</PageTitle>
            </PageHeader>

            <TabBar>
                <TabButton
                    active={activeTab === 'details'}
                    onClick={() => setActiveTab('details')}
                    icon={<MdDashboard className="icon" />}
                >
                    {t('Venues.VenueView.tabs.details')}
                </TabButton>
                <TabButton
                    active={activeTab === 'statistics'}
                    onClick={() => setActiveTab('statistics')}
                    icon={<MdBarChart className="icon" />}
                >
                    {t('Venues.VenueView.tabs.statistics')}
                </TabButton>
                <TabButton
                    active={activeTab === 'integration'}
                    onClick={() => setActiveTab('integration')}
                    icon={<MdCode className="icon" />}
                >
                    {t('Venues.VenueView.tabs.integration')}
                </TabButton>
                <TabButton
                    active={activeTab === 'edit'}
                    onClick={() => setActiveTab('edit')}
                    icon={<MdEdit className="icon" />}
                >
                    {t('Venues.VenueView.tabs.edit')}
                </TabButton>
            </TabBar>

            <PageContent>
                {activeTab === 'details' && <VenueDetails venue={venue} />}
                {activeTab === 'statistics' && <VenueStatistic venueId={venue.id} />}
                {activeTab === 'integration' && <VenueIntegration venueId={venue.id} />}
                {activeTab === 'edit' && <VenueForm venue={venue} onSave={handleSave} />}
            </PageContent>
        </PageContainer>
    );
};

export default VenueView;
